import { render } from "./AdminArticles.vue?vue&type=template&id=445f2cfb&scoped=true"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"

import "./AdminArticles.vue?vue&type=style&index=0&id=445f2cfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445f2cfb"]])

export default __exports__